import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../models/types';

interface ListDashboardsVars {
  clientId: string;
  datasource: string;
  autoRefresh?: string;
  createdAfter?: string;
  indexState?: string;
}

const GQL_LIST_DASHBOARDS = gql`
  query listDashboards($clientId: String!, $datasource: String!, $autoRefresh: String, $createdAfter: String, $indexState: String) {
    listDashboards(clientId: $clientId, datasource: $datasource, autoRefresh: $autoRefresh, createdAfter: $createdAfter, indexState: $indexState)
  }
`;

export const useListDashboardsQuery = () => {
  return useLazyQuery<AnyObject, ListDashboardsVars>(GQL_LIST_DASHBOARDS, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};
